import { render, staticRenderFns } from "./r-boat-order-page.vue?vue&type=template&id=47ca714e"
import script from "./r-boat-order-page.vue?vue&type=script&lang=js"
export * from "./r-boat-order-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47ca714e')) {
      api.createRecord('47ca714e', component.options)
    } else {
      api.reload('47ca714e', component.options)
    }
    module.hot.accept("./r-boat-order-page.vue?vue&type=template&id=47ca714e", function () {
      api.rerender('47ca714e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/boats/r-boat-order-page.vue"
export default component.exports